import { createContext } from 'react';

export const ManagerContext =  createContext ();